

    
export type FormDefinitionType = 'SalesOrder' | 'Customer';

export const FormDefinitionType = {
    SalesOrder: 'SalesOrder' as FormDefinitionType,
    Customer: 'Customer' as FormDefinitionType
};

